import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const LiveStudioCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    
    if (code) {
      // Redirect to Live Studio with the code
      navigate(`/live-studio?code=${code}&state=${state || ''}`);
    } else {
      // No code, just redirect back
      navigate('/live-studio');
    }
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900/20 to-gray-900 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-purple-500 mx-auto mb-4" />
        <p className="text-purple-200">Connecting to Restream...</p>
      </div>
    </div>
  );
};

export default LiveStudioCallback;
